import { render, staticRenderFns } from "./workPlateList.vue?vue&type=template&id=3b4cc99b&scoped=true&"
import script from "./workPlateList.vue?vue&type=script&lang=js&"
export * from "./workPlateList.vue?vue&type=script&lang=js&"
import style0 from "./workPlateList.vue?vue&type=style&index=0&id=3b4cc99b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4cc99b",
  null
  
)

export default component.exports